class CountdownTimer extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['days-group', 'days', 'hours-group', 'hours']
  }

  static get requiredAttributes () {
    return ['data-countdown-timer-target']
  }

  connectedCallback () {
    super.connectedCallback()

    this.target = new Date(
      this.getAttribute('data-countdown-timer-target').replace(' ', 'T'),
    ).getTime()

    this.tick = this.tick.bind(this)
    this.tick()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.interval) clearInterval(this.interval)
  }

  tick () {
    const remaining = Math.max(this.target - Date.now(), 0)

    const days = Math.floor(remaining / 86400000)
    const hours = Math.floor((remaining % 86400000) / 3600000)
    const minutes = Math.floor((remaining % 3600000) / 60000)
    const seconds = Math.floor((remaining % 60000) / 1000)

    const hideDays = days === 0
    const hideHours = hideDays && hours === 0

    this.els['days-group'].element.hidden = hideDays
    this.els['hours-group'].element.hidden = hideHours

    this.els.days.element.textContent = String(days).padStart(2, '0')
    this.els.hours.element.textContent = String(hours).padStart(2, '0')

    if (this.els['minutes-group']?.exists) {
      this.els['minutes-group'].element.hidden = hideHours && minutes === 0
      this.els.minutes.element.textContent = String(minutes).padStart(2, '0')
    }

    if (this.els.seconds?.exists) {
      this.els.seconds.element.textContent = String(seconds).padStart(2, '0')
    }

    if (remaining <= 0) {
      if (this.interval) clearInterval(this.interval)

      return
    }

    if (!this.interval) {
      this.interval = setInterval(this.tick, 1000)
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer)
}
